// Modules
import { de, enGB } from "date-fns/locale";

/**
 * The locales.
 */
export const LOCALES: Record<"en" | "de", Locale> = {
    en: enGB,
    de: de
};

/**
 * Gets the date-fns locale for the given lang code.
 * If not found returns de as a fallback.
 *
 * @param {String} lang the locale lang code
 * @returns the date-fns locale
 */
export function getLocaleByLang(lang: string) {
    return LOCALES[lang] || de;
}
